//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Chart from './chart';

export default {
    name: 'home-chart',
    props: {
        //报表列表
        reportList: Array,
        //报表数据
        firstReportData: Array,
        fullScreen: { type: Boolean, default: false },
        fullChartIndex: { type: Number, default: 0 },
        requestUrl: { type: String, default: '' },
    },
    created() {
        this.setChartData(0, this.firstReportData);
        this.$nextTick(t => {
            //定位横屏前的chart
            if (this.fullChartIndex) {
                this.chartTabIndex = this.fullChartIndex;
                this.$refs.swipe1.swipeTo(this.fullChartIndex)
            }
        })
    },
    data() {
        return {
            chartTabIndex: 0,
            allChartLength: this.reportList.length,
            chartDatas: [],
            swipeItemWidth: 'auto'
        }
    },
    methods: {
        changeSwipe(index) {
            this.changedBySwipe = true;
            this.chartTabIndex = index;
            this.changeChartTab();
            this.$nextTick(t => this.changedBySwipe = false)
        },
        changeChartTab() {
            if (!this.changedBySwipe) {
                this.$refs.swipe1.swipeTo(this.chartTabIndex)
            }
            if (!this.chartDatas[this.chartTabIndex]) {
                const url = this.reportList[this.chartTabIndex].type + '/getChartData';
                const reportId = this.reportList[this.chartTabIndex].id;

                this.$x.post(url, { id: reportId })
                    .then(res => {
                        this.setChartData(this.chartTabIndex, res)
                    })

            }
        },
        arrowSwipe(index) {
            var chartTabIndex = this.chartTabIndex + index;
            this.$refs.swipe1.swipeTo(chartTabIndex)
        },
        setChartData(index, data) {
            if (data && this.reportList) {
                const arr = [...this.chartDatas];
                arr[index] = this.parseChartData(data, this.reportList[index]);
                this.chartDatas = arr;
            }
        },
        getChartType(index) {
            const report = (this.reportList && this.reportList[this.chartTabIndex]) || {};
            return report.reporttype
        },
        parseChartData(data, report) {
            if (!data.length) return {};
            const legends = this.getAttrs(report, 'xvaltitle_');
            let colors = ['#5b8ff9', '#5ad8a6', '#f6bc15', '#e86453', '#5d7092'];//图形颜色
            if (legends.length > colors.length) colors = legends.map((l, i) => colors[i % colors.length]); //循环取
            const values = data.map(row => {
                return {
                    xTitle: row.x_title,
                    vals: this.getAttrs(row, 'xval_', legends.length),
                }
            });
            const options = {
                legend: {
                    show: true,
                    bottom: 2,
                    icon: 'circle',
                    textStyle: {
                        fontSize: 8
                    },
                },
                grid: {
                    left: 40,
                    right: 15,
                    top: 20,
                    bottom: 51
                },
            };
            const type = this.getChartType();
            var chartOption = type === 'pie'
                ? this.getPieOption(options, values, colors, type)
                : this.getBarLineOption(legends, values, colors, type); // bar , line
            return { ...options, ...chartOption }
        },
        getPieOption: function (options, values, colors, type) {
            options.legend.show = false;
            return {
                series: {
                    data: values.map((val, i) => ({
                        name: val.xTitle,
                        value: val.vals[0],
                        label: {
                            fontSize: 8,
                            formatter(l) {
                                return `${l.name}(${l.value})`
                            }
                        },
                        itemStyle: {
                            color: colors[i],
                        },
                        labelLine: {
                            length: 5,
                            length2: 3
                        }
                    })),
                    type,
                    itemStyle: {
                        borderWidth: 1,
                        borderColor: '#fff',
                    },
                }
            };
        },
        getBarLineOption: function (legends, values, colors, type) {
            const fullScreen = this.fullScreen;
            return {
                xAxis: {
                    type: 'category',
                    data: values.map(v => v.xTitle),
                    axisLabel: {
                        interval: 0,
                        color: '#777',
                        fontSize: 8,
                        formatter: function (value, index) { //x轴标签太长时换行
                            const provideNumber = fullScreen ? 5 : 3; //每行最大显示字数
                            const maxLine = Math.min(Math.ceil(value.length / provideNumber), 3);//最大显示行数
                            let newValue = '';
                            for (var i = 0; i < maxLine; i++) {
                                const start = i * provideNumber;
                                const end = (i + 1) * provideNumber;
                                const wordbreak = i == maxLine - 1 ? '' : '\n';
                                newValue += value.substring(start, end) + wordbreak
                            }
                            return newValue
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#e9e9e9'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: {
                        color: '#888',
                        fontSize: 8
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#e9e9e9'
                        }
                    }
                },
                series: legends.map((legend, i) => ({
                    name: legend,
                    data: values.map(item => ({
                        value: item.vals[i],
                        itemStyle: {
                            color: colors[i]
                        },
                        symbol: 'circle'
                    })),
                    type,
                    smooth: true,
                    label: {
                        show: true,
                        fontSize: 8,
                        position: 'top'
                    },
                    itemStyle: {
                        color: colors[i],
                        barBorderRadius: [5, 5, 0, 0]
                    },
                }))
            };
        },
        getAttrs(obj, prefix, count) {
            let i = 1;
            const result = [];
            while (1) {
                const key = prefix + i;
                const val = obj[key];
                if (val == null && (!count || i > count)) break;
                result.push(val);
                i++
            }
            return result
        },
        openFullChart(index) {
            if (!this.fullScreen) {
                this.$router.push({
                    path: '/fullScreenChart',
                    replace: true,
                    query: { index: index, requestUrl: this.requestUrl }
                })
            }
        }
    },
    mounted() {
        if (this.fullScreen) {
            const swipe = this.$x('.van-swipe')[0];
            this.swipeItemWidth = swipe.offsetWidth;
        }
    },
    components: { Chart },
}
